module.exports = __webpack_public_path__ + "static/media/services-submenu-personal-guide.63638398.png";